import { c as _c } from "react/compiler-runtime";
import PendingActionsIcon from '@mui/icons-material/PendingActions';
export const Pending = t0 => {
  const $ = _c(2);
  const {
    onClick
  } = t0;
  let t1;
  if ($[0] !== onClick) {
    t1 = <PendingActionsIcon onClick={onClick} />;
    $[0] = onClick;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};